export const UNAUTHORIZED_STATUS_CODE = 401
export const USER_HAS_NOT_REGISTERED_ERROR_CODE = 900
export const USER_HAS_ALREADY_REGISTERED_ERROR_CODE = 901
export const SERVER_ERROR = 500
export const REFRESH_TOKEN_ENDPOINT = '/Identity/RefreshToken'
